import './ExperienceSkeleton.scss';

const ExperienceSkeleton = () => {

    return (
        <>
            <div className="home__other__services__skeleton">
                <div className="left__side__other__services__skeleton">
                    <div className="other__services__content__skeleton">
                        <div className="other__services__accent__skeleton"></div>
                        <div className="other__services__title__skeleton"></div>
                        <div className="other__services__title__skeleton--primary"></div>
                        {[...Array(5)].map((_, i) => (
                            <div key={i} className="other__services__subtitle__skeleton"></div>
                        ))}
                        <div className="other__services__subtitle__skeleton--primary"></div>
                    </div>
                </div>
                <div className='right__side__other__services__skeleton'>
                    {[...Array(6)].map((_, index) => (
                        <div key={index} className={index % 2 === 0
                            ? 'right__side__other__services__item__skeleton'
                            : 'other__services__item__link__skeleton'
                        }>
                            {index % 2 !== 0 && (
                                <>
                                    <div className='other__services__item__title__skeleton'></div>
                                    <div className='other__services__item__title__skeleton--primary'></div>
                                    {[...Array(3)].map((_, i) => (
                                        <div key={i} className='other__services__item__text__skeleton'></div>
                                    ))}
                                    <div className='other__services__item__text__skeleton--primary'></div>
                                </>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default ExperienceSkeleton;